import { Link } from "react-router-dom";
import { Home, PackageSearch } from "lucide-react";

export default function NotFound() {
  return (
    <div className="container-x py-20 text-center">
      <p className="font-display font-bold text-7xl sm:text-8xl text-slate-200">404</p>
      <h1 className="text-2xl font-bold text-slate-900 mt-2">Page not found</h1>
      <p className="text-slate-500 mt-2 max-w-sm mx-auto">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/" className="inline-flex items-center gap-2 bg-slate-900 text-white font-semibold px-5 py-3 rounded-lg"><Home className="h-4 w-4" /> Go Home</Link>
        <Link to="/shop" className="inline-flex items-center gap-2 border border-slate-200 font-semibold px-5 py-3 rounded-lg"><PackageSearch className="h-4 w-4" /> Browse Shop</Link>
      </div>
    </div>
  );
}
